"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SchoolOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SchoolOutlineSVG = function SchoolOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,28H28V22h1a1,1,0,0,0,0-2H20.53C22.72,18,24,13.45,24,12a4.83,4.83,0,0,0-4.94-5A5.54,5.54,0,0,0,17,7.55V7a.92.92,0,0,1,1-1,1,1,0,0,0,0-2,2.91,2.91,0,0,0-3,3v.55A5.54,5.54,0,0,0,12.94,7,4.83,4.83,0,0,0,8,12c0,1.45,1.28,6,3.47,8H5a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3H29a1,1,0,0,0,0-2ZM10,12a2.84,2.84,0,0,1,2.94-3,4.67,4.67,0,0,1,1.64.57A2.86,2.86,0,0,0,16,9.93a2.79,2.79,0,0,0,1.41-.36A4.78,4.78,0,0,1,19.06,9,2.84,2.84,0,0,1,22,12c0,1.83-2.12,7-3.67,7a2.4,2.4,0,0,1-.84-.33,2.85,2.85,0,0,0-3,0,2.61,2.61,0,0,1-.84.33C12.12,19,10,13.83,10,12ZM26,28H4.89a1,1,0,0,1,0-2H26Zm0-4H5a1,1,0,0,1,0-2H26Z"
  }));
};
exports.SchoolOutlineSVG = SchoolOutlineSVG;
SchoolOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SchoolOutlineSVG);
exports.default = _default;